module.exports = __webpack_public_path__ + "static/media/logo.57a0cadc.png";